interface State {
  DeliveryPricingList: any[];
  DeliveryPricingCount: number;
  DeliveryMarkupPercentage: number;
}

const initialState: State = {
  DeliveryPricingList: [],
  DeliveryPricingCount: 0,
  DeliveryMarkupPercentage: 0,
};

export const DeliveryPricingReducer = (
  state: State = initialState,
  action: any,
): State => {
  switch (action.type) {
    case "GET_DELIVERY_PRICING_DATA":
      return {
        ...state,
        DeliveryPricingList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.DeliveryPricingList, ...action.payload.data],
        DeliveryPricingCount: action.payload.count,
      };

    case "UPDATE_DELIVERY_PRICING_DATA":
      return {
        ...state,
        DeliveryPricingList: state.DeliveryPricingList.map((item: any) =>
          item._id === action.payload._id ? action.payload : item,
        ),
      };

    case "GET_DELIVERY_MARKUP_DATA":
      return {
        ...state,
        DeliveryMarkupPercentage: action.payload,
      };

    case "CLEAR_DELIVERY_PRICING_DATA":
      return {
        ...state,
        DeliveryPricingList: [],
        DeliveryPricingCount: 0,
      };

    default:
      return state;
  }
};
